export default function (mobile) {
    mobile += '';
    return mobile.substr(0, 3) + '****' + mobile.substr(7);
}
